export class TokenCaptureLink
{
    public token: string;
    public mimeType: string;
    public snapshot: any = null;
    public assessmentFulfillment: any;
}
